import _extends from "@babel/runtime/helpers/extends";
import { SwitchProductModule } from '@wix/package-picker-sdk';
import { getMaxPricingDetailsDiscountPercent } from '@wix/package-picker-shared';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
import { useEffectiveRecommendation } from '../../hooks/useEffectiveRecommendation';
import { ProductHatUi } from './ProductHatUi';
export const useProductHat = _ref => {
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    data: {
      isCurrentProduct
    } = {
      isCurrentProduct: false
    }
  } = SwitchProductModule.SDK.switchApiClient.hooks.useIsCurrentProduct({
    productId
  });
  const discountPercent = getMaxPricingDetailsDiscountPercent(product == null ? void 0 : product.pricingDetails);
  const {
    recommendedDisplayText,
    isRecommended: catalogIsRecommended,
    hasSale
  } = product ?? {};
  const {
    isRecommended,
    isAiRecommended
  } = useEffectiveRecommendation(productId, catalogIsRecommended ?? false);
  const renderProductHat = function (props) {
    if (props === void 0) {
      props = {};
    }
    if (isCurrentProduct) {
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "currentProduct",
        text: t('premium-purchase-plan.cards.hat.current_plan')
      }, props));
    }
    if (hasSale) {
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "sale",
        text: discountPercent !== undefined ? t('sale.product.x_off', {
          percent: discountPercent
        }) : t('premium-purchase-plan.cards.hat_sale')
      }, props));
    }
    if (isRecommended) {
      return /*#__PURE__*/React.createElement(ProductHatUi, _extends({
        variant: "recommended",
        text: isAiRecommended ? t('premium-purchase-plan.cards.hat.recommended') : recommendedDisplayText ?? '',
        isRevealing: isAiRecommended
      }, props));
    }
    return /*#__PURE__*/React.createElement(ProductCardList.Default.Card.Tag, _extends({
      height: props.height ?? '30px',
      isVisible: true
    }, props));
  };
  return {
    renderProductHat,
    isProductHat: catalogIsRecommended || hasSale || isCurrentProduct
  };
};
//# sourceMappingURL=useProductHat.js.map